'use client'

import React from 'react'
import { useLanguage } from '@contexts/LanguageContext'

const STUDENTS_SUPPORTED = 216
const STUDENTS_GOAL_2026 = 5000

const ImpactStats: React.FC = () => {
  const { t } = useLanguage()
  const goalPercentage = (STUDENTS_SUPPORTED / STUDENTS_GOAL_2026) * 100

  const stats = [
    {
      icon: '📚',
      number: '120+',
      label: t('booksDistributed'),
      description: t('booksDistributedDesc'),
      color: '#667eea',
    },
    {
      icon: '👨‍🏫',
      number: '20',
      label: t('teachersTrained'),
      description: t('teachersTrainedDesc'),
      color: '#f56565',
    },
    {
      icon: '🌍',
      number: '1',
      label: t('regionsServed'),
      description: t('regionsServedDesc'),
      color: '#48bb78',
    },
    {
      icon: '🏫',
      number: '2',
      label: t('schoolsSupported'),
      description: t('schoolsSupportedDesc'),
      color: '#38b2ac',
    },
    {
      icon: '💰',
      number: t('totalFundingAmount'),
      label: t('totalFunding'),
      description: t('totalFundingDesc'),
      color: '#ed8936',
    },
  ]

  return (
    <section className="impact-stats-modern">
      <div className="container">
        {/* Section Header */}
        <div className="section-header-modern">
          <span className="section-label">{t('ourImpact')}</span>
          <h2 className="section-title-modern">{t('makingRealDifference')}</h2>
          <p className="section-desc-modern">{t('impactStatsDesc')}</p>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid-modern">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="stat-card-modern"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="stat-icon-wrapper" style={{ backgroundColor: `${stat.color}20` }}>
                <span className="stat-icon-large">{stat.icon}</span>
              </div>
              <div className="stat-number-modern" style={{ color: stat.color }}>
                {stat.number}
              </div>
              <h3 className="stat-label-modern">{stat.label}</h3>
              <p className="stat-desc-modern">{stat.description}</p>
            </div>
          ))}
        </div>

        {/* Progress Bar */}
        <div className="overall-progress">
          <div className="progress-header">
            <div>
              <h4>{t('annualGoalProgress')}</h4>
              <p>{t('annualGoalProgressDesc')}</p>
            </div>
            <div className="progress-percentage">{Math.round(goalPercentage)}%</div>
          </div>
          <div className="progress-bar-container">
            <div className="progress-bar-fill" style={{ width: `${goalPercentage}%` }}>
              <div className="progress-shimmer"></div>
            </div>
          </div>
          <div className="progress-footer">
            <span>{t('goalProgressStatus')}</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ImpactStats
